import Modal from 'react-modal'
import { TMapBasicData } from '@/tmapBasicInfo/TMapBasicData'
import { TBoxItemLogic } from '@/tmapBasicInfo/tboxInfo/TBoxItemLogic'
import { TBOX_CONTENTS_LIST } from '@/constants/TBoxConstants'
import { ChangeEvent, useState, useRef } from 'react'

type Props = {
  isOpen: boolean
  basicData: TMapBasicData
  floor: number
  boxIndex: number
  closeModal: () => void
}

const TimeTableModal = ({ isOpen, basicData, floor, boxIndex, closeModal }: Props) => {
  // #region フック

  const [, dispatch] = useState({})

  const checkboxList = useRef<{ name: string; probability: number }[]>([])

  const checkedFilterList = useRef<string[]>([])

  // #endregion フック

  // #region スタイル

  const modalStyle: Modal.Styles = {
    overlay: {
      position: 'fixed',
      top: 0,
      left: 0,
      backgroundColor: 'rgba(240,240,240,0.7)'
    },
    content: {
      position: 'absolute',
      backgroundColor: '#f0f0f0',
      border: 'solid 1px #000000',
      top: '4%',
      left: '37%',
      right: '37%',
      bottom: '4%',
      padding: '0px'
    }
  }

  const headerStyle: React.CSSProperties = {
    margin: '5px 0px 0px 10px'
  }

  const mainStyle: React.CSSProperties = {
    margin: '0px 10px 10px 10px'
  }

  const infoStyle: React.CSSProperties = {
    lineHeight: '10px'
  }

  const filterAreaStyle: React.CSSProperties = {
    border: 'solid 1px',
    height: '190px',
    overflowY: 'scroll'
  }

  const tableAreaStyle: React.CSSProperties = {
    border: 'solid 1px',
    height: '400px',
    overflowY: 'scroll'
  }

  const tableStyle: React.CSSProperties = {
    width: '100%'
  }

  const buttonsStyle: React.CSSProperties = {
    marginTop: '10px',
    textAlign: 'right'
  }

  const secondColumnStyle: React.CSSProperties = {
    width: '160px'
  }

  // #endregion スタイル

  // #region イベント

  const onAfterOpenModal = () => {
    const tBoxRank = TBoxItemLogic.getTBoxRank(basicData, floor, boxIndex)
    if (tBoxRank !== -1) {
      checkboxList.current = TBOX_CONTENTS_LIST[tBoxRank]
      checkedFilterList.current = checkboxList.current.map((s) => s.name)
    }
    dispatch({})
  }

  const onChangeFilter = (e: ChangeEvent<HTMLInputElement>) => {
    if (checkedFilterList.current.includes(e.target.value)) {
      checkedFilterList.current = checkedFilterList.current.filter((s) => s !== e.target.value)
    } else {
      checkedFilterList.current = [...checkedFilterList.current, e.target.value]
    }
    dispatch({})
  }

  const onChangeSelectAll = (e: ChangeEvent<HTMLInputElement>) => {
    const bool = e.target.checked ? true : false
    if (bool) {
      checkedFilterList.current = checkboxList.current.map((s) => s.name)
    } else {
      checkedFilterList.current = []
    }
    dispatch({})
  }

  // #endregion イベント

  if (floor < 0 || floor > basicData.mapFloorCount || boxIndex < 0) {
    return (
      <Modal isOpen={isOpen} style={modalStyle} ariaHideApp={false}>
        <h1>取得失敗</h1>
      </Modal>
    )
  }

  const head = (
    <thead>
      <tr>
        <th style={secondColumnStyle}>秒数</th>
        <th>宝箱の中身</th>
      </tr>
    </thead>
  )

  const list = []
  for (let i = 6; i <= 600; i++) {
    const name = TBoxItemLogic.calculateTBoxContents(basicData, floor, boxIndex, i)
    if (checkedFilterList.current.includes(name)) {
      list.push({
        key: `${basicData.mapRank}-${basicData.mapSeed}-${i}`,
        seconds: i,
        name: name
      })
    }
  }

  const body = (
    <tbody>
      {list.map((s) => (
        <tr key={s.key}>
          <td align='right'>{s.seconds}s</td>
          <td>{s.name}</td>
        </tr>
      ))}
    </tbody>
  )

  return (
    <Modal isOpen={isOpen} ariaHideApp={false} style={modalStyle} onAfterOpen={onAfterOpenModal}>
      <h1 style={headerStyle}>中断技タイムテーブル</h1>
      <main style={mainStyle}>
        <p style={infoStyle}>
          {basicData.mapName1.name}
          {basicData.mapName2.name}
          {basicData.mapName3.name}
          Lv{basicData.mapLevel}の地図（0x{basicData.mapRank.toString(16).padStart(2, '0').toUpperCase()} 0x
          {basicData.mapSeed.toString(16).padStart(4, '0').toUpperCase()}）
        </p>
        <p style={infoStyle}>
          B{floor}F 第{boxIndex + 1}箱
        </p>
        表示アイテム絞り込み：
        <br />
        <div style={filterAreaStyle}>
          <label htmlFor='select-all'>
            <input
              type='checkbox'
              id='select-all'
              value='select-all'
              checked={checkedFilterList.current.length === checkboxList.current.length}
              onChange={onChangeSelectAll}
            />
            <b>全て選択</b>
            <br />
          </label>
          {checkboxList.current.map((s) => (
            <label key={s.name} htmlFor={s.name}>
              <input
                type='checkbox'
                id={s.name}
                value={s.name}
                checked={checkedFilterList.current.includes(s.name)}
                onChange={onChangeFilter}
              />
              {s.name}
              <br />
            </label>
          ))}
        </div>
        <br />
        タイムテーブル：
        <br />
        <div style={tableAreaStyle}>
          <table border={1} style={tableStyle}>
            {head}
            {body}
          </table>
        </div>
        <div style={buttonsStyle}>
          <button onClick={closeModal}>閉じる</button>
        </div>
      </main>
    </Modal>
  )
}

export { TimeTableModal }
